import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';
import LoadingSpinner from './LoadingSpinner';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { state } = useApp();
  const location = useLocation();

  if (state.loading) {
    return <LoadingSpinner fullScreen tip="正在验证身份..." />;
  }

  if (!state.isAuthenticated) {
    // 保存当前路径，登录后可以跳转回来
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  // 检查是否需要初始化密码
  if (state.user && !state.user.is_initialized) {
    return <Navigate to="/auth/initialize-password" replace />;
  }

  // 检查是否需要验证OTP
  if (state.user && state.user.otp_enabled && !state.user.otp_verified) {
    return <Navigate to="/auth/verify-otp" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;